<section class="section-pd list-wrapper-style-2 pt-0 pb-40">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>自訂檢視模式<br class="d-md-block d-none"/>依需求調整建議提醒</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>個別建議提醒</h3>
                    <p>在專屬提醒卡片中逐字檢視建議，並可選擇接受或忽略。</p>
                    <ul class="bt-list">
                        <li>逐項審核建議，避免資訊過載。</li>
                        <li>一次聚焦單一提醒，提升審核效率。</li>
                        <li>強化對建議的掌控與調整彈性，確保內容品質。</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/individual-alerts.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>句子建議提醒</h3>
                    <p>在單一提醒卡片中檢視該句所有建議，並可一鍵接受或忽略。 </p>
                    <ul class="bt-list">
                        <li>一次修正整句，節省審核時間。</li>
                        <li>減少提醒建議通知，降低資訊干擾。</li>
                        <li>可於句中接受或忽略逐字建議，提高操作效率。 <span class="beta-badges" style="margin-left:5px">Coming Soon</span></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/sentence-alerts.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>氣泡建議提醒</h3>
                    <p>在寫作區直接看到建議和提醒，讓你專注又不分心！</p>
                    <ul class="bt-list">
                        <li>寫作空間更大，讓你完全沉浸在創作中。</li>
                        <li>隨時隨地輕鬆修正，寫得更順手！</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="text-center">
                    <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                        <source src="/assets/images/features/grammar-checker/Bubble-view.mp4" type="video/mp4">
                        Your browser does not support the video element. Kindly update it to latest version.
                    </video>
                </div>
            </div>
        </div>
    </div>
</section>